// GENERATED FILE - DO NOT MODIFY
export enum ClientStatus {
    Active = "A",
    Blocked = "B",
    Warning = "W",
}

export let nameof = "ClientStatus";
